import type { MutationKey } from 'react-query';
import { useIsMutating } from 'react-query';

export function useIsLoadingMutation(mutationKey: MutationKey) {
  const mutations = useIsMutating(mutationKey);

  return mutations > 0;
}